var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGymnasiums(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 21,
    fill: "#F2EFFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 14C13.4404 14 14 14.5596 14 15.25V18H28V15.25C28 14.5596 28.5596 14 29.25 14H31.75C32.4404 14 33 14.5596 33 15.25V25.75C33 26.4404 32.4404 27 31.75 27H29.25C28.5596 27 28 26.4404 28 25.75V23H14V25.75C14 26.4404 13.4404 27 12.75 27H10.25C9.55964 27 9 26.4404 9 25.75V15.25C9 14.5596 9.55964 14 10.25 14H12.75ZM31.75 15H29.25C29.1119 15 29 15.1119 29 15.25V25.75C29 25.8881 29.1119 26 29.25 26H31.75C31.8881 26 32 25.8881 32 25.75V15.25C32 15.1119 31.8881 15 31.75 15ZM12.75 15H10.25C10.1119 15 10 15.1119 10 15.25V25.75C10 25.8881 10.1119 26 10.25 26H12.75C12.8881 26 13 25.8881 13 25.75V15.25C13 15.1119 12.8881 15 12.75 15ZM35 17.25V24.75H34V17.25H35ZM8 17.25V24.75H7V17.25H8ZM28 19H14V22H28V19Z",
    fill: "#ffcc3c"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGymnasiums);
export default __webpack_public_path__ + "static/media/gymnasiums.20ca2c8b54712967f7aca4f285d878ca.svg";
export { ForwardRef as ReactComponent };